<app-loading-screen *ngIf="show">Loading Annual Statement Comparison Report</app-loading-screen>
<form>
    <div>
        <div class="pagetitle">Annual Statement Comparison: {{ currentYear }}</div>
        <div *ngIf="compno!==null">
            <span class="pagetitleSecondLayerBold"> {{ prfNumber }} </span>:<span class="pagetitleSecondLayer">
                {{ prfName }}</span>
            <a *ngIf="!isCustomer && !isReadOnlyAdmin && annualstatementlist.length" 
            class="emailBtn interactive-links" 
            (click)="email()">
                <span class="table-material-icons email-icon">
                    email
                </span>
                Email
            </a>
        </div>
    </div>
    <br/>
    <div class="information" *ngIf="showPageError">
        <div class="messagetitle"><i class="table-material-icons">error</i> {{pageError}}</div>
    </div>
    <div>
        <div *ngIf="iconNote" class="note"><i class="table-material-icons">flag</i> =
            Annual Statement and Premium Report Totals
            do not match</div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Columns</th>
                    <th scope="col">Annual Statement</th>
                    <th scope="col">Premium Values</th>
                    <th>Premium Difference</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of annualstatementlist;let row=index">
                    <td>{{ (item.Text!=='Total') ? row+1 : ""}}</td>
                    <td>{{item.Text}} </td>
                    <td>{{item.col1 | currency :'USD':symbol:'1.0-2'}}</td>
                    <td>{{item.col2 | currency :'USD':symbol:'1.0-2'}}</td>
                    <td>{{item.diff | currency :'USD':symbol:'1.0-2'}} <i *ngIf="item.mark !==''"
                            class="table-material-icons">flag</i> </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>